import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-promo-content",
  "use": "icon-soc-mall-promo-content-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-promo-content\">\n<g fill=\"currentColor\">\n  <rect x=\"180\" y=\"160\" width=\"520\" height=\"700\" rx=\"28\" opacity=\"0.2\" />\n  <rect x=\"240\" y=\"240\" width=\"400\" height=\"56\" rx=\"12\" />\n  <rect x=\"240\" y=\"340\" width=\"340\" height=\"40\" rx=\"10\" opacity=\"0.7\" />\n  <rect x=\"240\" y=\"420\" width=\"380\" height=\"40\" rx=\"10\" opacity=\"0.55\" />\n  <rect x=\"240\" y=\"500\" width=\"300\" height=\"40\" rx=\"10\" opacity=\"0.4\" />\n  <path d=\"M700 620l120 40-40 120-120-40 40-120z\" opacity=\"0.85\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-promo-content.svg
// module id = 6fQx
// module chunks = 491